import { api, LightningElement, wire } from "lwc";

import { MenuAdapter, MENU_ADAPTER_DEFAULT_VALUE } from "common/menuAdapter";
import { assignedSlotNames } from "common/slot";
import { createTrack } from "common/track";
import { attrToBool, hash } from "common/helpers";
import { withImageProxy } from "common/withImageProxy";

export type MenuOption = {
  href: string;
  target?: string | null;
  label: string;
  key?: string;
};

export default class extends LightningElement {
  @wire(MenuAdapter, { template: "$template", items: "$menuItems" })
  private menu = MENU_ADAPTER_DEFAULT_VALUE;

  @api
  get open() {
    return this.menu.state.open;
  }

  set open(value: string | boolean) {
    attrToBool(value) ? this.menu.open() : this.menu.close();
  }

  @api fullName: string = undefined!;
  @api menuOptions: MenuOption[] = [];
  @api bannerPhotoUrl: string = undefined!;
  @api avatarUrl: string = undefined!;
  @api logoutLabel: string = undefined!;
  @api logoutHref: string = undefined!;

  private track = createTrack<"tds-user-menu">(this);
  private proxyAvatarURL: string = "";

  async connectedCallback() {
    this.proxyAvatarURL = await withImageProxy(this.avatarUrl);
  }

  get hasCustomTrigger(): boolean {
    return this.activeSlots.includes("trigger");
  }

  private activeSlots: string[] = [];

  // This is for the MenuAdapter since the logout item is not part of `menuOptions`
  private get menuItems() {
    return this.menuOptions.concat({ href: "#", label: "logout" });
  }

  private get options() {
    return this.menuOptions.map((option) =>
      // HACK: For some reason, using the spread operator causes Chromatic break
      Object.assign({}, option, {
        key: `item_${hash(option.label)}`,
      })
    );
  }

  private get bannerStyle() {
    return `background-image: url(${this.bannerPhotoUrl});`;
  }

  private get bannerPhotoStyle() {
    return `background-image: url(${this.proxyAvatarURL});`;
  }

  private onSlotChange() {
    this.activeSlots = assignedSlotNames(this.template);
  }

  private handleLinkClick(e: Event) {
    const item = e.target as HTMLElement;
    this.track("link_clicked", {
      label: item.textContent!,
      href: item.getAttribute("href"),
    });
  }
}
